import { Search } from "@mui/icons-material";
import {
  Box,
  InputAdornment,
  MenuItem,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import DropDown from "../../../components/dropDown";
import MovieCard from "../../../components/MovieCard";
import LocationChooser from "./locationChooser";
import { useEffect, useState } from "react";
import removeDuplicateMovies from "../../../utilities/removeDuplicateMovies";

/**A component that renders a list of movie cards
 * @param {Object} props
 * @param {string} props.experience can be '2D' or '3D', will be used to filter movies
 * @param {Function} props.handleExperience A function used to update experience state and filter the movies
 * @param {Object[]} props.movies A List of movies
 * @param {boolean} props.moviesTab whether this component is being rendered on the movies tab or in a
 * cinema card
 * @param {string} props.cinema_Name The name of the cinema, used if {@link props.moviesTab} is true
 * @param {string} props.cinema_id The id of the cinema
 * @param {string} props.searchQuery A state value used to search for movies
 * @param {Function} props.handleSearchQuery A function used to update searchQuery state and filter movies
 */
const MovieList = ({
  experience,
  handleExperience,
  movies,
  moviesTab = true,
  cinema_Name,
  cinema_id,
  searchQuery,
  handleSearchQuery,
  locations = [],
}) => {
  const [movieListFinal, setMovieListFinal] = useState([]);

  useEffect(() => {
    setMovieListFinal(removeDuplicateMovies(movies));
  }, [movies]);
  return (
    <>
      <Stack
        direction={{
          xs: "column",
          sm: "row",
        }}
        sx={{ justifyContent: "space-between" }}
        spacing={1}
        pr={"2vw"}
        pb="0.5vh"
        pt="0.5vh"
        overflow="hidden"
      >
        {moviesTab ? (
          <>
            {locations.length > 1 ? (
              <LocationChooser locations={locations} />
            ) : (
              <Box></Box>
            )}
          </>
        ) : (
          <Typography
            variant="h6"
            fontSize={{
              xs: "0.775rem",
              sm: "1.25rem",
            }}
          >
            Showing at {cinema_Name}
          </Typography>
        )}
        <Stack direction={"row"} spacing={2} alignItems="center" p={1}>
          <TextField
            label="Search movies"
            size="small"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
            }}
            value={searchQuery}
            onChange={handleSearchQuery}
          />
          <DropDown value={experience} onChange={handleExperience}>
            <MenuItem value={"2D/3D"}>2D/3D</MenuItem>
            <MenuItem value={"2D"}>2D</MenuItem>
            <MenuItem value={"3D"}>3D</MenuItem>
          </DropDown>
        </Stack>
      </Stack>
      <Stack direction="row" sx={{ flexWrap: "wrap" }}>
        {movieListFinal.map((movie, index) => {
          return (
            <MovieCard
              key={movie.MovieID}
              movieName={movie.MovieName}
              imgsrc={movie.MovieImageSmall}
              rating={movie.CensorRating}
              genre={["movie.genre"]}
              id={movie.MovieID}
              cinemaId={cinema_id}
              experience={"2D"}
            />
          );
        })}
      </Stack>
    </>
  );
};

export default MovieList;
